import React from "react";
import { TextField } from "@mui/material";
import { FormAutoComplete } from "./FormAutoComplete";

// Drop-in customer picker for any module/dialog. Pairs a plain search
// TextField with the existing, unmodified FormAutoComplete - typing
// calls searchCustomers (from useCustomerSearch) to hit
// /customer/search, keeping dataArray small instead of holding every
// customer at once.
//
// Usage:
//   const { customerOptions, customerLoading, searchCustomers } =
//     useCustomerSearch(customerList);
//
//   <CustomerPickerField
//     name="customer_ids"
//     control={control}
//     errors={errors}
//     multiple
//     customerOptions={customerOptions}
//     searchCustomers={searchCustomers}
//     defaultValue={...}
//   />
export const CustomerPickerField = ({
  name,
  control,
  errors,
  multiple = true,
  label = "Customers",
  searchLabel = "Search customers by name or mobile",
  customerOptions,
  searchCustomers,
  defaultValue,
}) => {
  return (
    <>
      <TextField
        fullWidth
        size="small"
        label={searchLabel}
        placeholder="Type to search..."
        onChange={(e) => searchCustomers(e.target.value)}
        sx={{ mb: 1.5 }}
      />
      <FormAutoComplete
        name={name}
        control={control}
        label={label}
        multiple={multiple}
        dataArray={customerOptions}
        errors={errors}
        defaultValue={defaultValue}
      />
    </>
  );
};